<template>
  <app-modal
    :modal-id="modalId"
    modal-alignment="top"
    modal-size="large"
    @close-modal="closeModal"
  >
    <template slot="header">
      <h5 class="modal-title">{{ $t("view_document") }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>
    <template slot="body">
      <div class="form-group row align-items-center" v-if="document_category != null">
        <label for="inputsdocument_category" class="col-sm-3 mb-0">
          {{ $t("document_category") }}
        </label>
        <app-input
          id="inputs_document_category"
          class="col-sm-9"
          type="text"
          v-model="document_category"
          :disabled="true"
        />
      </div>
      <div class="form-group row align-items-center">
        <label for="inputs_type" class="col-sm-3 mb-0">
          {{ $t("type") }}
        </label>
        <app-input
          id="inputs_type"
          class="col-sm-9"
          type="text"
          v-model="inputs.type"
          :disabled="true"
        />
      </div>
      <div class="form-group row align-items-center">
        <label for="inputs_document_name" class="col-sm-3 mb-0">
          {{ $t("document_name") }}
        </label>
        <app-input
          id="inputs_document_name"
          class="col-sm-9"
          type="text"
          v-model="inputs.document_name"
          :disabled="true"
        />
      </div>
      <div class="form-group row align-items-center">
        <label for="inputs_phone" class="col-sm-3 mb-0">
          {{ $t("expiry_date") }}
        </label>
        <app-input
          id="inputs_expiry_date"
          class="col-sm-9"
          type="date"
          v-model="inputs.expiry_date"
          :disabled="true"
        />
      </div>
      <div class="form-group row align-items-center" v-if="fields.length > 0" v-for="($item, $index) in fields" :key="$index">
        <label for="inputs_phone" class="col-sm-3 mb-0">
          {{ $item.field }}
        </label>
        <app-input
          id="inputs_expiry_date"
          class="col-sm-9"
          type="text"
          v-model="$item.value"
          :disabled="true"
        />
      </div>
      <div class="row">
        <div class="col-md-12">
          <label for="text_input">
            {{ $t("download_files") }}
          </label>
          <div class="row">
            <div class="col-sm-6 col-md-6 mb-3">
              <a :href="documentFiles.path" download>
                <app-widget
                  class="mb-primary"
                  :type="'app-widget-with-icon'"
                  :label="documentFiles.name"
                  :icon="'image'"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        {{ $t("close") }}
      </button>
      <!-- <button
        type="button"
        class="btn btn-primary mr-2"
        data-dismiss="modal"
        @click="submit"
      >
        {{ $t("update") }}
      </button> -->
    </template>
  </app-modal>
</template>

<script>
import { ModalMixin } from "../../../../../../app/Mixins/ModalMixin";
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin";
import {axiosGet} from "../../../../../../app/Helpers/AxiosHelper";
import {MY_DOCUMENT_INFO} from "../../../../../Config/ApiUrl";
import CoreLibrary from "../../../../../../core/helpers/CoreLibrary.js";

export default {
  name: "Tabs",

  extends: CoreLibrary,
  mixins: [ModalMixin, FormMixin],
  props: {
    id: Number,
  },
  data() {
    return {
      document_category: '',
      inputs: {},
      modalId: "demo-view-Modal",
      documentFiles:{},
      fields: [],
    };
  },
  methods: {
    getDocumentInfo() {
      axiosGet(MY_DOCUMENT_INFO + "/" + this.id)
        .then((response) => {
          this.inputs = response.data;
          this.inputs.document_name = response.data.name;
          this.document_category = response.data.document_category;
          this.documentFiles = response.data.file;
          this.fields = response.data.extraFields;
          
          this.preloader = false;
        })
        .catch((error) => {
          
        });
    },
  },
  mounted() {
    this.getDocumentInfo();
  },
};
</script>
